import React, { useMemo } from "react";
import { ExamTimeWay, ExamType } from "../../../../service/exam";
import moment from "moment";

interface ExamTimeProps {
    type: ExamType;
    startTime: string;
    endTime: string;
    timeType: ExamTimeWay;
}

export default function ExamTime({
    type,
    startTime,
    endTime,
    timeType
}: ExamTimeProps) {
    const start = useMemo(() => moment(startTime), [startTime]);
    const end = useMemo(() => moment(endTime), [endTime]);

    if (!startTime || !endTime) return <span>未设置</span>;
    if (type === ExamType.Thesis || timeType === ExamTimeWay.free)
        return (
            <span>
                {start.format("MM-DD HH:mm")} - {end.format("MM-DD HH:mm")}
            </span>
        );
    return (
        <span>
            {start.format("YYYY-MM-DD")} {start.format("HH:mm")} -{" "}
            {end.format("HH:mm")}
        </span>
    );
}
